"use client";

import createIcon from './util/createIcon';
export default createIcon('M8.5,18.31L5.69,15.5L12.06,9.12H7.11V5.69H18.31V16.89H14.89V11.94L8.5,18.31Z', 'ArrowTopRightThick');